module.exports = {
	"_from": "git://github.com/frozeman/WebSocket-Node.git#browserifyCompatible",
	"_id": "websocket@1.0.26",
	"_inBundle": false,
	"_integrity": "",
	"_location": "/websocket",
	"_phantomChildren": {},
	"_requested": {
		"type": "git",
		"raw": "websocket@git://github.com/frozeman/WebSocket-Node.git#browserifyCompatible",
		"name": "websocket",
		"escapedName": "websocket",
		"rawSpec": "git://github.com/frozeman/WebSocket-Node.git#browserifyCompatible",
		"saveSpec": "git://github.com/frozeman/WebSocket-Node.git#browserifyCompatible",
		"fetchSpec": "git://github.com/frozeman/WebSocket-Node.git",
		"gitCommittish": "browserifyCompatible"
	},
	"_requiredBy": [
		"/web3-providers-ws"
	],
	"_resolved": "git://github.com/frozeman/WebSocket-Node.git#6c72925e3f8aaaea8dc8450f97627e85263999f2",
	"_spec": "websocket@git://github.com/frozeman/WebSocket-Node.git#browserifyCompatible",
	"_where": "/home/marko/EthereumAsyncProjects/AsyncCoinContract/node_modules/web3-providers-ws",
	"author": {
		"name": "Brian McKelvey",
		"email": "brian@worlize.com",
		"url": "https://www.worlize.com/"
	},
	"browser": "lib/browser.js",
	"bugs": {
		"url": "https://github.com/theturtle32/WebSocket-Node/issues"
	},
	"bundleDependencies": false,
	"config": {
		"verbose": false
	},
	"contributors": [
		{
			"name": "Iñaki Baz Castillo",
			"email": "ibc@aliax.net",
			"url": "http://dev.sipdoc.net"
		}
	],
	"dependencies": {
		"debug": "^2.2.0",
		"nan": "^2.3.3",
		"typedarray-to-buffer": "^3.1.2",
		"yaeti": "^0.0.6"
	},
	"deprecated": false,
	"description": "Websocket Client & Server Library implementing the WebSocket protocol as specified in RFC 6455.",
	"devDependencies": {
		"buffer-equal": "^1.0.0",
		"faucet": "^0.0.1",
		"gulp": "git+https://github.com/gulpjs/gulp.git#4.0",
		"gulp-jshint": "^2.0.4",
		"jshint": "^2.0.0",
		"jshint-stylish": "^2.2.1",
		"tape": "^4.0.1"
	},
	"directories": {
		"lib": "./lib"
	},
	"engines": {
		"node": ">=0.10.0"
	},
	"homepage": "https://github.com/theturtle32/WebSocket-Node",
	"keywords": [
		"websocket",
		"websockets",
		"socket",
		"networking",
		"comet",
		"push",
		"RFC-6455",
		"realtime",
		"server",
		"client"
	],
	"license": "Apache-2.0",
	"main": "index",
	"name": "websocket",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/theturtle32/WebSocket-Node.git"
	},
	"scripts": {
		"gulp": "gulp",
		"install": "(node-gyp rebuild 2> builderror.log) || (exit 0)",
		"test": "faucet test/unit"
	},
	"version": "1.0.26"
};


//////////////////
// WEBPACK FOOTER
// ./~/websocket/package.json
// module id = 434
// module chunks = 0